import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import ButtonV2 from '@components/ui/ButtonV2/Button'
import ContainerV2 from '@components/ui/ContainerV2/ContainerV2'
import Media from '@components/ui/Media/Media'
import { M9Fragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'

import useMediaQuery from '@lib/hooks/useMediaQuery'
import { CSSProperties, FC, useEffect, useState } from 'react'
import s from './M9.module.scss'
export interface M9Props extends M9Fragment {
  headlineVariant: 'Kings Caslon' | 'Helvetica Neue' | 'Mixed Fonts'
  textColor: 'White' | 'Black'
}
const M9: FC<M9Props> = ({
  headline,
  headlineFontType,
  headlineVariant,
  textContent,
  contentButton,
  textColor,
  backgroundColor,
  image1,
  image2,
  imagePosition,
  ...props
}) => {
  const isMobileBreakingPoint = useMediaQuery('(max-width: 640px)')
  const [medias, setMedias] = useState({ 1: image1, 2: image2 })

  switch (imagePosition) {
    case 'Left':
      imagePosition = 'left'
      break
    case 'Right':
      imagePosition = 'right'
      break
    case 'Reversed':
      imagePosition = 'reversed'
      break
    default:
      imagePosition = 'defailt'
  }

  useEffect(() => {
    if (isMobileBreakingPoint) {
      setMedias({ 1: image2, 2: image1 })
    } else {
      setMedias({ 1: image1, 2: image2 })
    }
  }, [isMobileBreakingPoint])

  return (
    <ContainerV2 backgroundColor={backgroundColor} fluid>
      <div
        className={clsx(
          s.root,
          { [s.reversed]: imagePosition === 'reversed' },
          { [s.left]: imagePosition === 'left' },
          { [s.right]: imagePosition === 'right' },
        )}
        style={
          textColor
            ? ({ '--color': textColor.toLowerCase() } as CSSProperties)
            : undefined
        }
      >
        <div className={s.wrapper}>
          <div
            className={clsx(
              s.innerWrapper,
              { [s.reversed]: imagePosition === 'reversed' },
              { [s.left]: imagePosition === 'left' },
              { [s.right]: imagePosition === 'right' },
            )}
          >
            {/* <HeaderVariation headline={headline} textColor={textColor} className={s.headline} /> */}
            <h2
              className={clsx(
                s.headline,
                headlineFontType?.length > 0 ? headlineFontType : 'headline-4',
              )}
            >
              {' '}
              {headline}
            </h2>

            <div className={clsx(s.desktop, s.textContent)}>
              <TrustedHtml html={textContent} />
            </div>

            <div className={clsx(s.desktop, s.buttonContainer)}>
              {contentButton && (
                <div className={s.buttonContaier}>
                  <ButtonV2
                    style={
                      {
                        '--border-color': textColor?.toLowerCase(),
                        '--color': textColor?.toLowerCase(),
                      } as CSSProperties
                    }
                    className={s.uppercase}
                    as={Link}
                    link={contentButton}
                    size="medium"
                  >
                    {contentButton.name}
                  </ButtonV2>
                </div>
              )}
            </div>
            <Link link={contentButton} className={s.firstImage}>
              <Media
                mediaClassName={s.fullSize}
                mediaWithCrops={medias[1]}
                sizes="(max-width: 1024px) 90vw, 20vw"
              />
            </Link>
          </div>
        </div>

        <div
          className={clsx(
            s.wrapper,
            { [s.reversed]: imagePosition === 'reversed' },
            { [s.left]: imagePosition === 'left' },
            { [s.right]: imagePosition === 'right' },
          )}
        >
          <Link link={contentButton} className={s.secondImage}>
            <Media
              mediaClassName={s.fullSize}
              mediaWithCrops={medias[2]}
              sizes="50vw"
            />
          </Link>

          <div
            className={clsx(s.mobile, s.textContent)}
            style={
              textColor
                ? ({ '--color': textColor.toLowerCase() } as CSSProperties)
                : undefined
            }
          >
            <TrustedHtml html={textContent} />{' '}
            {contentButton && (
              <div className={clsx(s.mobile, s.buttonContainer)}>
                <div className={s.buttonContaier}>
                  <ButtonV2
                    style={
                      {
                        '--borderColor': textColor?.toLowerCase(),
                        '--color': textColor?.toLowerCase(),
                      } as CSSProperties
                    }
                    className={s.uppercase}
                    as={Link}
                    size="medium"
                    link={contentButton}
                  >
                    {contentButton.name}
                  </ButtonV2>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ContainerV2>
  )
}

export default M9
